<template>
	<div>
		<div
			style="width: 210px;padding-top: 9px;padding-bottom: 9px;font-size: 14px;margin: auto;text-align: center;background-color: #aaa7a7;border-radius: 10px 10px 0px 0px;border-bottom: solid 1px #c6c6c6;">
			{{selectdItem.compontChildren[0].name + '设置'}}
		</div>

		<div class="item">
			<div style="">标题内容</div>

		</div>
		<div class="item">
			<el-input type="textarea" :rows="2" placeholder="请输入内容"
				v-model="selectdItem.compontChildren[0].layoutConfig.tit">
			</el-input>
		</div>

		<div class="item">
			<div style="display: flex;align-items: center;">
				<el-select size="mini" style="width: 130px;"
					v-model="selectdItem.compontChildren[0].layoutConfig.titleFontFamily" placeholder="选择字体">
					<el-option v-for="(fontItem,index) in fontList" :key="index" :label="fontItem.code"
						:value="fontItem.name">
					</el-option>
				</el-select>
				<el-color-picker size="mini" v-model="selectdItem.compontChildren[0].layoutConfig.titColor"
					style="margin-left: 3px;"></el-color-picker>

				<div
					style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
					<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
						:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
						:value="selectdItem.compontChildren[0].layoutConfig.titleSize"
						@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.titleSize = e}"></wm-input-number>
				</div>
			</div>
		</div>
		
		
		<div style="display: flex;justify-content: space-between;align-items: center;margin: 6px;">
			<div style="">
				是否加粗
			</div>
			<div 
				style="display: flex;align-items: center;margin-left:8px;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.isBold = true"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.isBold ?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.isBold ?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.isBold ?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;cursor: pointer;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.isBold = false"
					:style="{backgroundColor:!selectdItem.compontChildren[0].layoutConfig.isBold?'#8c62ff':'#fff',color:!selectdItem.compontChildren[0].layoutConfig.isBold?'#fff':'#000',border:!selectdItem.compontChildren[0].layoutConfig.isBold?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;cursor: pointer;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>
		
		<div class="item">
			<div>标题与输入框间距</div>
			<div
				style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
				<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
					:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
					:value="selectdItem.compontChildren[0].layoutConfig.titleMarTop"
					@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.titleMarTop = e}"></wm-input-number>
			</div>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">输入框大小</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.size = ''"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.size == ''?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.size == ''?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.size == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">大号</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.size = 'medium'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.size == 'medium'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.size == 'medium'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.size == 'medium'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">中号</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.size = 'mini'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.size == 'mini'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.size == 'mini'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.size == 'mini'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">小号</span>
				</div>
			</div>
		</div>
		<div class="item">
			<div>输入框长度</div>
			<wm-input-number :iptWidth="60" :disabled="false" :styleObj="{width: '100px',height: '32px'}" :step="1"
				:min="1" :max="10000000" :value="selectdItem.compontChildren[0].layoutConfig.width"
				@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.width = e}"></wm-input-number>
		</div>
		
		<div class="item">
			<div>输入框边框颜色</div>
		</div>
		
		<div class="item">
			<div>默认颜色</div>
			
			<el-color-picker size="mini" @change="(e)=>{
				selectdItem.compontChildren[0].layoutConfig.borIptDedaultColor = e
			}" style="height: 28px;width: 28px;margin-top: 4px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.borIptDedaultColor"></el-color-picker>
		</div>
		<div class="item">
			<div>选中颜色</div>
			
			<el-color-picker size="mini" @change="(e)=>{
				selectdItem.compontChildren[0].layoutConfig.borIptColor = e
			}" style="height: 28px;width: 28px;margin-top: 4px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.borIptColor"></el-color-picker>
		</div>
		
		<div class="item">
			<div>悬停颜色</div>
			
			<el-color-picker size="mini" @change="(e)=>{
				selectdItem.compontChildren[0].layoutConfig.borIptHoverColor = e
			}" style="height: 28px;width: 28px;margin-top: 4px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.borIptHoverColor"></el-color-picker>
		</div>

		<div class="item">
			<div>按钮长度</div>
			<wm-input-number :iptWidth="60" :disabled="false" :styleObj="{width: '100px',height: '32px'}" :step="1"
				:min="1" :max="10000000" :value="selectdItem.compontChildren[0].layoutConfig.btn.width"
				@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.btn.width = e}"></wm-input-number>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">按钮大小</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.btn.size = ''"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.btn.size == ''?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.btn.size == ''?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.btn.size == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">大号</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.btn.size = 'medium'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.btn.size == 'medium'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.btn.size == 'medium'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.btn.size == 'medium'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">中号</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.btn.size = 'mini'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.btn.size == 'mini'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.btn.size == 'mini'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.btn.size == 'mini'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">小号</span>
				</div>
			</div>
		</div>

		<div class="item">
			<div>按钮字体颜色</div>
			<el-color-picker size="mini" @change="(e)=>{
				selectdItem.compontChildren[0].layoutConfig.btn.fontColor = e
			}" style="height: 28px;width: 28px;margin-top: 4px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.btn.fontColor"></el-color-picker>
		</div>
		
		<div class="item">
			<div>按钮字体大小</div>
			<wm-input-number :iptWidth="60" :disabled="false" :styleObj="{width: '100px',height: '32px'}" :step="1"
				:min="1" :max="10000000" :value="selectdItem.compontChildren[0].layoutConfig.btn.fontSize"
				@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.btn.fontSize = e}"></wm-input-number>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">组件边框</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.btn.border.type = ''"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.btn.border.type == ''?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.btn.border.type == ''?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.btn.border.type == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">无</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.btn.border.type = 'solid'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.btn.border.type == 'solid'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.btn.border.type == 'solid'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.btn.border.type== 'solid'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">实线</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.btn.border.type = 'dashed'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.btn.border.type == 'dashed'?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.btn.border.type == 'dashed'?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.btn.border.type == 'dashed'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">虚线</span>
				</div>
			</div>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">边框颜色</div>
			<el-color-picker size="mini" style="height: 34px;width: 34px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.btn.border.color"></el-color-picker>
			<el-input size="mini" style="height: 34px;width: 82px;" disabled
				:value="selectdItem.compontChildren[0].layoutConfig.btn.border.color"></el-input>
		</div>
		
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div v-if="selectdItem.compontChildren[0].layoutConfig.btn.border.borderSize" style="margin-top: 10px;">
				<div>线条大小</div>
				<div
					style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.compontChildren[0].layoutConfig.btn.border.borderSize[0]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">顶部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.compontChildren[0].layoutConfig.btn.border.borderSize[1]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.compontChildren[0].layoutConfig.btn.border.borderSize[2]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">底部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.compontChildren[0].layoutConfig.btn.border.borderSize[3]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">右侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
						<i @click="borderContainerSizeAll = !borderContainerSizeAll"
							:style="{color:borderContainerSizeAll?'#8c62ff':'#000'}"
							style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
							class="el-icon-paperclip tit-icon"></i>
					</div>
				</div>
			</div>
		</div>
		

		<div style="display: flex;justify-content: space-between;align-items: center;margin: 6px;">
			<div style="">
				按钮背景
			</div>
			<div v-if="selectdItem.compontChildren[0].layoutConfig.btn.bg.bgtype"
				style="display: flex;align-items: center;margin-left:8px;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.btn.bg.bgtype = 'color'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.btn.bg.bgtype == 'color'?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.btn.bg.bgtype == 'color'?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.btn.bg.bgtype == 'color'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
					<span style="scale: 0.85;">纯色</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.btn.bg.bgtype = 'gradient'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.btn.bg.bgtype == 'gradient'?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.btn.bg.bgtype == 'gradient'?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.btn.bg.bgtype == 'gradient'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
					<span style="scale: 0.85;">渐变</span>
				</div>
			</div>
		</div>


		<div style="display: flex;justify-content: center;cursor: pointer;">
			<div style="background-color: #F6F7F9;display: flex;flex-direction: column;">

				<div v-if="selectdItem.compontChildren[0].layoutConfig.btn.bg.bgtype == 'gradient'"
					style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
					<div
						style="width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
						<div style="display: flex;flex-direction: column;">
							<div style="display: flex;align-items: center;">
							</div>
							<el-input style="width: 172px;margin-top: 4px;" type="textarea" :rows="3"
								placeholder="请输入内容"
								v-model="selectdItem.compontChildren[0].layoutConfig.btn.bg.bgGradient">
							</el-input>
						</div>
						<div style="margin-top: 6px;font-size: 12px;color: #55aaff;">
							需要更多模板设置请访问 <a target="_blank" style="margin-left: 4px;"
								href="https://www.eggradients.com/">Gradient1</a> <a style="margin-left: 4px;"
								target="_blank" href="https://webgradients.com/">Gradient2</a>
						</div>
					</div>
				</div>
				<div v-if="selectdItem.compontChildren[0].layoutConfig.btn.bg.bgtype && selectdItem.compontChildren[0].layoutConfig.btn.bg.bgtype == 'color'"
					style="display: flex;justify-content: center;margin-top: 10px;width: 210px;margin-bottom: 20px;font-size: 12px;">
					<div
						style="display: flex;align-items: center;background-color: #F6F7F9;height: 34px;width: 210px;justify-content: space-around;">
						<div style="font-size: 12px;">
							背景纯色
						</div>
						<el-color-picker size="mini" @change="(e)=>{
								selectdItem.compontChildren[0].layoutConfig.btn.bg.color = e
							}" style="height: 28px;width: 28px;margin-top: 4px;"
							v-model="selectdItem.compontChildren[0].layoutConfig.btn.bg.color"></el-color-picker>
					</div>
				</div>
			</div>
		</div>


		<div class="item">
			<div>按钮字体悬停颜色</div>
			<el-color-picker size="mini" @change="(e)=>{
				selectdItem.compontChildren[0].layoutConfig.btn.hoverColor = e
			}" style="height: 28px;width: 28px;margin-top: 4px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.btn.hoverColor"></el-color-picker>
		</div>

		<div style="display: flex;justify-content: space-between;align-items: center;margin: 6px;">
			<div style="">
				按钮悬停背景
			</div>
			<div v-if="selectdItem.compontChildren[0].layoutConfig.btn.hoverBg.bgtype"
				style="display: flex;align-items: center;margin-left:8px;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.btn.hoverBg.bgtype = 'color'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.btn.hoverBg.bgtype == 'color'?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.btn.hoverBg.bgtype == 'color'?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.btn.hoverBg.bgtype == 'color'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
					<span style="scale: 0.85;">纯色</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.btn.hoverBg.bgtype = 'gradient'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.btn.hoverBg.bgtype == 'gradient'?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.btn.hoverBg.bgtype == 'gradient'?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.btn.hoverBg.bgtype == 'gradient'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
					<span style="scale: 0.85;">渐变</span>
				</div>
			</div>
		</div>

		<div style="display: flex;justify-content: center;cursor: pointer;">
			<div style="background-color: #F6F7F9;display: flex;flex-direction: column;">

				<div v-if="selectdItem.compontChildren[0].layoutConfig.btn.hoverBg.bgtype == 'gradient'"
					style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
					<div
						style="width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
						<div style="display: flex;flex-direction: column;">
							<div style="display: flex;align-items: center;">
							</div>
							<el-input style="width: 172px;margin-top: 4px;" type="textarea" :rows="3"
								placeholder="请输入内容"
								v-model="selectdItem.compontChildren[0].layoutConfig.btn.hoverBg.bgGradient">
							</el-input>
						</div>
						<div style="margin-top: 6px;font-size: 12px;color: #55aaff;">
							需要更多模板设置请访问 <a target="_blank" style="margin-left: 4px;"
								href="https://www.eggradients.com/">Gradient1</a> <a style="margin-left: 4px;"
								target="_blank" href="https://webgradients.com/">Gradient2</a>
						</div>
					</div>
				</div>
				<div v-if="selectdItem.compontChildren[0].layoutConfig.btn.hoverBg.bgtype && selectdItem.compontChildren[0].layoutConfig.btn.hoverBg.bgtype == 'color'"
					style="display: flex;justify-content: center;margin-top: 10px;width: 210px;margin-bottom: 20px;font-size: 12px;">
					<div
						style="display: flex;align-items: center;background-color: #F6F7F9;height: 34px;width: 210px;justify-content: space-around;">
						<div style="font-size: 12px;">
							背景纯色
						</div>
						<el-color-picker size="mini" @change="(e)=>{
								selectdItem.compontChildren[0].layoutConfig.btn.hoverBg.color = e
							}" style="height: 28px;width: 28px;margin-top: 4px;"
							v-model="selectdItem.compontChildren[0].layoutConfig.btn.hoverBg.color"></el-color-picker>
					</div>
				</div>
			</div>
		</div>


		<div style="width: 100%;height: 1px;background-color: #aaa7a7;margin-top: 6px;"></div>
		
		<div class="item">
			<div>标题字体颜色</div>
			<el-color-picker size="mini" @change="(e)=>{
				selectdItem.compontChildren[0].layoutConfig.labelColor = e
			}" style="height: 28px;width: 28px;margin-top: 4px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.labelColor"></el-color-picker>
		</div>
		
		<div class="item">
			<div>标题字体大小</div>
			
			<div
				style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
				<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
					:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
					:value="selectdItem.compontChildren[0].layoutConfig.labelFontSize"
					@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.labelFontSize = e}"></wm-input-number>
			</div>
		</div>
		
		<div style="display: flex;justify-content: space-between;align-items: center;margin: 6px;">
			<div style="">
				是否加粗
			</div>
			<div
				style="display: flex;align-items: center;margin-left:8px;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.isLabelBold = true"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.isLabelBold ?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.isLabelBold ?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.isLabelBold ?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;cursor: pointer;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.isLabelBold = false"
					:style="{backgroundColor:!selectdItem.compontChildren[0].layoutConfig.isLabelBold?'#8c62ff':'#fff',color:!selectdItem.compontChildren[0].layoutConfig.isLabelBold?'#fff':'#000',border:!selectdItem.compontChildren[0].layoutConfig.isLabelBold?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;cursor: pointer;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>
		<div class="item">
			<div>输入框间距</div>
			
			<div
				style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
				<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
					:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
					:value="selectdItem.compontChildren[0].layoutConfig.iptMarBto"
					@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.iptMarBto = e}"></wm-input-number>
			</div>
		</div>
		<div class="item">
			<div>文字与输入框间距</div>
			
			<div
				style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
				<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
					:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
					:value="selectdItem.compontChildren[0].layoutConfig.titMarBto"
					@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.titMarBto = e}"></wm-input-number>
			</div>
		</div>
		
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 12px;">
			<div style="font-size: 12px;">名称显示</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.name.show = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.name.show?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.name.show?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.name.show?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.name.show = false"
					:style="{backgroundColor: !selectdItem.compontChildren[0].layoutConfig.name.show?'#8c62ff':'#fff',color: !selectdItem.compontChildren[0].layoutConfig.name.show?'#fff':'#000',border: !selectdItem.compontChildren[0].layoutConfig.name.show?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 6px;">
			<div style="font-size: 12px;">名称必填</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.name.isRequire = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.name.isRequire?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.name.isRequire?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.name.isRequire?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.name.isRequire = false"
					:style="{backgroundColor: !selectdItem.compontChildren[0].layoutConfig.name.isRequire?'#8c62ff':'#fff',color: !selectdItem.compontChildren[0].layoutConfig.name.isRequire?'#fff':'#000',border: !selectdItem.compontChildren[0].layoutConfig.name.isRequire?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 12px;">
			<div style="font-size: 12px;">邮箱显示</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.email.show = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.email.show?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.email.show?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.email.show?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.email.show = false"
					:style="{backgroundColor: !selectdItem.compontChildren[0].layoutConfig.email.show?'#8c62ff':'#fff',color: !selectdItem.compontChildren[0].layoutConfig.email.show?'#fff':'#000',border: !selectdItem.compontChildren[0].layoutConfig.email.show?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 6px;">
			<div style="font-size: 12px;">邮箱必填</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.email.isRequire = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.email.isRequire?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.email.isRequire?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.email.isRequire?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.email.isRequire = false"
					:style="{backgroundColor: !selectdItem.compontChildren[0].layoutConfig.email.isRequire?'#8c62ff':'#fff',color: !selectdItem.compontChildren[0].layoutConfig.email.isRequire?'#fff':'#000',border: !selectdItem.compontChildren[0].layoutConfig.email.isRequire?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 12px;">
			<div style="font-size: 12px;">手机显示</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.phone.show = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.phone.show?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.phone.show?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.phone.show?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.phone.show = false"
					:style="{backgroundColor: !selectdItem.compontChildren[0].layoutConfig.phone.show?'#8c62ff':'#fff',color: !selectdItem.compontChildren[0].layoutConfig.phone.show?'#fff':'#000',border: !selectdItem.compontChildren[0].layoutConfig.phone.show?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 6px;">
			<div style="font-size: 12px;">手机必填</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.phone.isRequire = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.phone.isRequire?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.phone.isRequire?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.phone.isRequire?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.phone.isRequire = false"
					:style="{backgroundColor: !selectdItem.compontChildren[0].layoutConfig.phone.isRequire?'#8c62ff':'#fff',color: !selectdItem.compontChildren[0].layoutConfig.phone.isRequire?'#fff':'#000',border: !selectdItem.compontChildren[0].layoutConfig.phone.isRequire?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 12px;">
			<div style="font-size: 12px;">地址显示</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.address.show = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.address.show?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.address.show?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.address.show?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.address.show = false"
					:style="{backgroundColor: !selectdItem.compontChildren[0].layoutConfig.address.show?'#8c62ff':'#fff',color: !selectdItem.compontChildren[0].layoutConfig.address.show?'#fff':'#000',border: !selectdItem.compontChildren[0].layoutConfig.address.show?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 6px;">
			<div style="font-size: 12px;">地址必填</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.address.isRequire = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.address.isRequire?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.address.isRequire?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.address.isRequire?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.address.isRequire = false"
					:style="{backgroundColor: !selectdItem.compontChildren[0].layoutConfig.address.isRequire?'#8c62ff':'#fff',color: !selectdItem.compontChildren[0].layoutConfig.address.isRequire?'#fff':'#000',border: !selectdItem.compontChildren[0].layoutConfig.address.isRequire?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>
		
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 12px;">
			<div style="font-size: 12px;">内容显示</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.content.show = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.content.show?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.content.show?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.content.show?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.content.show = false"
					:style="{backgroundColor: !selectdItem.compontChildren[0].layoutConfig.content.show?'#8c62ff':'#fff',color: !selectdItem.compontChildren[0].layoutConfig.content.show?'#fff':'#000',border: !selectdItem.compontChildren[0].layoutConfig.content.show?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 6px;">
			<div style="font-size: 12px;">内容必填</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.content.isRequire = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.content.isRequire?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.content.isRequire?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.content.isRequire?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.content.isRequire = false"
					:style="{backgroundColor: !selectdItem.compontChildren[0].layoutConfig.content.isRequire?'#8c62ff':'#fff',color: !selectdItem.compontChildren[0].layoutConfig.content.isRequire?'#fff':'#000',border: !selectdItem.compontChildren[0].layoutConfig.content.isRequire?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 6px;">
			<div style="font-size: 12px;">内容行高</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<wm-input-number :iptWidth="60" :disabled="false" :styleObj="{width: '100px',height: '32px'}" :step="1"
					:min="1" :max="10000000" :value="selectdItem.compontChildren[0].layoutConfig.content.row"
					@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.content.row = e}"></wm-input-number>
			</div>
		</div>
		
		<div class="item">
			<div style="">内容标题</div>
		</div>
		<div class="item">
			<el-input type="textarea" :rows="2" placeholder="请输入内容"
				v-model="selectdItem.compontChildren[0].layoutConfig.content.title">
			</el-input>
		</div>
		
		<div>
			<div>排序</div>
			<div style="width: 210px; display: flex;flex-direction: column;align-items: center;justify-content: center;">
				<draggable style="margin-top: 10px;" v-model="selectdItem.compontChildren[0].layoutConfig.sort"
					:group="{name: 'titset',pull:true,put:true,sort:true}" animation="500">
					<transition-group style="display: flex;flex-wrap: wrap;justify-content: center;">
						<div style="padding: 4px 6px;border: solid 1px #d5d5d5 ;background-color: #8c62ff;color: #fff;"
							v-for="(item,index) in selectdItem.compontChildren[0].layoutConfig.sort" :key="index">
							<i class="el-icon-rank"></i>
		
							{{item.label}}
						</div>
					</transition-group>
				</draggable>
				<div style="margin-top: 4px;font-size: 12px;color: #7d7d7d ;">拖拽选项卡排序</div>
			</div>
		</div>
	</div>
</template>
<script>
	import selectImg from '../components/selectImg.vue'
	import selectPage from '../cpm/selectPage.vue'
	import wmInputNumber from '../components/inputNumber.vue'
	import draggable from 'vuedraggable'
	export default {
		components: {
			wmInputNumber,
			selectPage,
			selectImg,
			draggable
		},
		props: {
			all_setting: {
				type: Array,
				default: []
			},
			goodsData: {
				type: Object,
				default: () => {
					return {}
				}
			},
			equipment: {
				type: String,
				default: "pc"
			},
			fontList: {
				type: Array,
				default: []
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
		},
		computed: {
			fontFamilyName: function() {
				if (this.all_setting.length > 0) {
					return this.all_setting[0].tabList[1].config.setfontFamily.name
				} else {
					return ''
				}
			}
		},
		data() {
			return {
				borderContainerSizeAll:true
			}
		},
		mounted() {
			if (!this.selectdItem.compontChildren[0].layoutConfig.titleFontFamily) {
				this.selectdItem.compontChildren[0].layoutConfig.titleFontFamily = this.fontFamilyName
			}
		},
		methods:{
			changeContainerSize(e) {
				if (this.borderContainerSizeAll) {
					this.selectdItem.compontChildren[0].layoutConfig.btn.border.borderSize = []
					this.selectdItem.compontChildren[0].layoutConfig.btn.border.borderSize.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.btn.border.borderSize.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.btn.border.borderSize.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.btn.border.borderSize.push(e.target.value)
				}
			},
		}
	}
</script>

<style scoped lang="scss">
	.item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 6px;
	}

	input:focus {
		outline: none;
		border: 1px solid #242754;
		border-radius: 3px;
	}

	input {
		outline: none;
		border: 1px solid #c1c1c1;
		border-radius: 5px;
	}

	.tit-icon:hover {
		color: #8c62ff;
	}
</style>